import { T_KeyValue } from "../types/app.type";
import { parseApiInput } from "./api.helper";

export const deepCopy = (data: T_KeyValue) => {
    return data ? JSON?.parse(JSON?.stringify(data)) : data;
}

export const isEmptyObject = (obj: T_KeyValue) => {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
};

export const toTitleCase = (str: string) => {
    return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

export const toSentenceCase = (str: string, delim?: string | undefined) => {
    if (delim) {
        return str.split(delim).map(s => (s ? s?.toLowerCase().charAt(0).toUpperCase() + s.slice(1) : s)).join(delim);
    } else {
        return str ? str?.toLowerCase().charAt(0).toUpperCase() + str.slice(1) : str;
    }
};

export const camelCaseToWords = (s: string) => {
    const result = s.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
}

export const range = (start: number = 0, end: number = 10, step: number = 1) => {
    let arr: number[] = [];
    for (let i: number = start; i < end; i = i + step) {
        arr.push(i);
    }
    return arr;
}

export const setThemeProp = ({ key = "", value = "" }: { key?: string, value: any }) => {
    if (typeof (value) === "string") {
        return value;
    } else {
        return value[key];
    }
}

export const objToQueryString = (obj: T_KeyValue) => {
    let str = "";
    let delim = "";
    for (const key in obj) {
        str += obj[key] ? `${delim}${key}=${obj[key]}` : "";
        delim = "&";
    }
    return str;
}

export const getUrl = ({ url = "", pathParams = [], queryParams = {} }: { url?: string | undefined, pathParams?: (string | number)[], queryParams?: T_KeyValue }) => {
    let newUrl = url || "";
    newUrl += pathParams ? "/" + pathParams.join("/") : "";
    newUrl += queryParams ? "?" + objToQueryString(queryParams) : "";

    return newUrl;
}

// export const responseToReadable = (response: any) => {
//     const reader = response?.body?.getReader();
//     const rs = new Readable();
//     rs._read = async () => {
//         const result = await reader?.read();
//         if (!result.done) {
//             rs?.push(Buffer?.from(result?.value));
//         } else {
//             rs?.push(null);
//             return;
//         }
//     };
//     return rs;
// };

// export const readCookie = (name: string) => {
//     var nameEQ = name + "=";

//     var ca = document.cookie.split(';');
//     for (var i = 0; i < ca.length; i++) {
//         var c = ca[i];
//         while (' ' == c?.charAt(0)) c = c?.substring(1, c.length);
//         if (0 == c?.indexOf(nameEQ)) return c?.substring(nameEQ?.length, c?.length);
//     }

//     return null;
// }

export const trim = (str: string = "", delim: string = '/'): string => {
    if (!str) return str;
    if (delim == str?.charAt(0)) str = str?.substr(1);
    if (delim == str?.charAt(str?.length - 1)) str = str?.substr(0, str?.length - 1);
    return str;
}

export const strToBool = (s: string = "") => {
    // will match one and only one of the string 'true','1', or 'on' regardless
    // of capitalization and regardless of surrounding white-space.
    //
    // regex=/^\s*(true|1|on)\s*$/i

    // return regex.test(s);

    return (["true", "TRUE", "True", "on", "ON", "On", "1"].includes(s) ? true : false);
}


// Circuit BackMerge Utils ----------------------------------
export const spaceUnit = 8;

export enum DesignLibraryVersion {
    "v1.0.0" = "v1.0.0",
    "v2.0.0" = "v2.0.0",
}

export const on = (obj: T_KeyValue, ...args: any) => {
    obj.addEventListener(...args)
}

export const off = (obj: T_KeyValue, ...args: any) => {
    obj.removeEventListener(...args)
}

export const toCamelCase = (str: string) => {
    return (str || "")?.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
    });
};

export const inputToNumber = (str: string): number => {
    // console.log("INPUT-NUM: ", str);
    const numberPattern = /\d+/g;
    let output: number = parseInt(str?.match(numberPattern)?.[0] || "100");
    // ["px", "%", "rem", "em", "vw", "vh"].forEach((suf: string) => {
    //     output = output.replace(suf, "");
    // })

    // console.log("NUM: ", output, str?.match(numberPattern)?.[0]);

    return output;
}

export const filterOfferItems = (res: any, props: any, slugList: string = "") => {
    const Entry = res?.res?.includes?.Entry; // List of resolved Entries
    const Assets = res?.res?.includes?.Asset; // List of resolved Assets
    const offersSlug = res?.res?.items?.[0]?.fields?.slug;

    const filteredEntryIds = res?.res?.items?.[0]?.fields?.offerItems?.map(
        (item: any) => item.sys.id
    ); // List of ids of all offerItems (errored/published/unpublished/drafted etc)

    let offerstList = Entry?.filter((item: any) => {
        return filteredEntryIds?.includes(item?.sys?.id);
    }); // List of published offerItems Data
    //filter on slugList if not empty
    if (slugList !== "") {
        offerstList = offerstList?.filter((item: any) => slugList?.includes(item?.fields?.slug));
        offerstList = slugList?.split(",")?.map((item: any) => {
            const offer = offerstList?.find((o: any) => o?.fields?.slug === item?.trim())
            if (offer) {
                return offer
            }
        })
    }
    const data = offerstList?.map((item: any) => {
        const tenantEntryDataObj = Entry?.find(
            (itemEntry: any) =>
                itemEntry?.sys?.id === item?.fields?.tenant?.sys?.id
        );

        if (!tenantEntryDataObj) {
            return {};
        }

        const brandEntryDataObj = Entry?.find(
            (itemEntry: any) =>
                itemEntry?.sys?.id ===
                tenantEntryDataObj?.fields?.brand?.sys?.id
        );

        if (!brandEntryDataObj) {
            return {};
        }

        const logoAsssetDataObj = Assets?.find(
            (itemAsset: any) =>
                itemAsset?.sys?.id === brandEntryDataObj.fields.logo.sys.id
        );

        if (!logoAsssetDataObj) {
            return {};
        }
        return {
            offerName: item?.fields?.name,
            validity: item?.fields.validTo,
            brandName: brandEntryDataObj?.fields.name,
            brandLogo: `https://${logoAsssetDataObj.fields.file.url.slice(
                2
            )}`, // Image src have // in the begining
            view_offer_link: `${props?.domain}${props?.domain?.endsWith("/") ? "" : "/"}${props?.arrayList?.sys.locale || "en"}/${offersSlug}/${item?.fields?.slug}`,
        };
    });

    return data;
}



export const filterEventItems = (res: any, props: any) => {
    // debugger;
    const Entry = res?.res?.includes?.Entry; // List of resolved Entries
    const Assets = res?.res?.includes?.Asset; // List of resolved Assets
    const eventsSlug = res?.res?.items?.[0]?.fields?.slug;

    const filteredEntryIds = res?.res?.items?.[0]?.fields?.eventItems?.map(
        (item: any) => item.sys.id
    ); // List of ids of all event items (errored/published/unpublished/drafted etc)

    const finalList = Entry?.filter((item: any) => {
        return filteredEntryIds?.includes(item?.sys?.id);
    }); // List of published event item Data

    const finalEventList = finalList?.map((item: any) => {
        // const imageUrl = Assets.find((asset: any) => asset?.sys?.id === item?.fields?.mediaField?.sys?.id);
        const resolvedEntry = Entry?.find((entry: any) => entry?.sys?.id === item?.fields?.mediaField?.sys?.id);
        const resolvedAsset = Assets?.find((asset: any) => asset?.sys?.id === resolvedEntry?.fields?.jsonBynderAsset?.id);
        const imageUrl = resolvedAsset ? `https:${resolvedAsset?.fields?.file?.url}` : resolvedEntry?.fields?.jsonBynderAsset?.originalUrl;
        const eventLink = `${props?.domain}${props?.domain?.endsWith("/") ? "" : "/"}${props?.arrayList?.sys.locale || "en"}/${eventsSlug}/${item?.fields?.slug}`;
        const eventTypes = item?.fields?.eventTypes?.map((eventType: any) => {
            return Entry?.find((entry: any) => entry?.sys?.id === eventType?.sys?.id)?.fields?.name;
        })
        const entryTags = item?.metadata?.tags?.map((tagItem: any) => {
                    return tagItem?.sys?.linkType === "Tag" ? tagItem?.sys?.id : null;
                }).filter((tag: any) => tag !== null);
                
        return (
            {
                eventName: item?.fields?.name,
                startDate: item?.fields?.startDate,
                endDate: item?.fields?.endDate,
                image: imageUrl,
                eventTypes,
                view_event_link: eventLink,
                slug: item?.fields?.slug,
                entryTags:item?.fields?.tags || [],
            }
        )
    })

    return finalEventList;
}

export const isValidSlug = ({ slug, allowedSlugs = [] }: { slug: string | string[], allowedSlugs: string[] }): boolean => {
    return allowedSlugs.includes(slug[0]);
}

export const validPageSlugs = async ({ routes, paramSlug }: { routes: string[], paramSlug: string | string[] }) => {
    let as: string[] = [];
    ((paramSlug && Array.isArray(paramSlug) ? paramSlug : [paramSlug]) || []).forEach((slg: string) => {
        if (routes?.includes(slg)) {
            as.push(slg);
        }
    })
    return as;
}

/** 
 * Generate and returns a random Hex Color code. 
 * @param {number} red - should be between [0, 255]
 * @param {number} green - should be between [0, 255]
 * @param {number} blue - should be between [0, 255]
 * @param {number} opacity - should be between [0, 100]
 * @returns {string} a hex color code exmple :- #ffffff
*/

export const getRandomHexColor = (red?: number, green?: number, blue?: number, opacity?: number) => {

    const rgbRange = (n?: number) => n === undefined ? Math.floor(Math.random() * 256) : Math.max(0, Math.min(255, n));

    const r = rgbRange(red)
    const g = rgbRange(green)
    const b = rgbRange(blue)

    const toHex = (n: number) => n.toString(16).padStart(2, "0");

    //   Check opacity Logic default 1, or opacity/100

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

// export const createURL = async ({ endPoint = "", pathParams = [], queryParams = {}, formData }: { endPoint: string, pathParams?: string[] | { [key: string]: string | number | boolean }[], queryParams?: { [key: string]: string | number | boolean }, formData?: { [key: string]: string | number | boolean } }): Promise<string> => {
//     let urlStr: string = endPoint;
//     console.log("urlStr step 1 --- ", {urlStr, endPoint, pathParams, queryParams, formData})

//     if (pathParams && pathParams?.length > 0) {
//         console.log("urlStr step 2 --- ", {urlStr, endPoint, pathParams, queryParams, formData})
//         pathParams?.forEach(async (param: string | { [key: string]: string | number | boolean }, index: number) => {
//             if (typeof (param) === "string") {
//                 urlStr += `/${param}`;
//                 console.log("urlStr step 3 --- ", {urlStr, endPoint, pathParams, queryParams, formData, param})
//             } else if (typeof param === 'object' && param !== null && (param?.hasOwnProperty('map') || param?.hasOwnProperty('preDefined'))) {
//                 const valueObj = await parseApiInput(formData, param);
//                 console.log("urlStr step 4 --- ", {urlStr, endPoint, pathParams, queryParams, formData, valueObj, param})
//                 for (const key in valueObj) {
//                     urlStr += `/${valueObj[key]}`;
//                     console.log("urlStr step 5 --- ", {urlStr, endPoint, pathParams, queryParams, formData, valueObj, param, key})
//                 }
//             } else if(typeof param === 'object' && param !== null) {
//                 console.log("urlStr step 6 --- ", {urlStr, endPoint, pathParams, queryParams, formData, param})
//                 for (const key in param) {
//                     urlStr += `/${key}/${param[key]}`;
//                     console.log("urlStr step 7 --- ", {urlStr, endPoint, pathParams, queryParams, formData, param, key })
//                 }
//             }
//         });
//     }
//     if (queryParams && Object.keys(queryParams).length > 0) {
//         urlStr += ``;
//         let delim = "?";
//         if (queryParams !== null && (queryParams?.hasOwnProperty('map') || queryParams?.hasOwnProperty('preDefined'))) {
//             const valueObj = await parseApiInput(formData, queryParams);
//             console.log("urlStr step 8 --- ", {urlStr, endPoint, pathParams, queryParams, formData, valueObj, delim})
//             for (const qpKey in valueObj) {
//                 urlStr += `${delim}${qpKey}=${queryParams[qpKey]}`;
//                 console.log("urlStr step 9 --- ", {urlStr, endPoint, pathParams, queryParams, formData, valueObj, qpKey, delim})
//                 delim = "&";
//             }
//         } else {
//             for (const qpKey in queryParams) {
//                 urlStr += `${delim}${qpKey}=${queryParams[qpKey]}`;
//                 console.log("urlStr step 10 --- ", {urlStr, endPoint, pathParams, queryParams, formData, qpKey, delim})
//                 delim = "&";
//             }
//         }
//     }

//     console.log("urlStr  step 20 --- ", {urlStr, endPoint, pathParams, queryParams, formData})

//     return urlStr;
// }

export const createURL = async ({
    endPoint = "",
    pathParams = [],
    queryParams = {},
    formData
}: {
    endPoint: string;
    pathParams?: Array<string | { [key: string]: string | number | boolean }>;
    queryParams?: { [key: string]: string | number | boolean };
    formData?: { [key: string]: string | number | boolean };
}): Promise<string> => {
    let urlStr: string = endPoint;

    console.log("urlStr step 1 --- ", { urlStr, endPoint, pathParams, queryParams, formData });

    // Fix 1: Use for...of instead of async forEach to properly await
    if (pathParams && pathParams.length > 0) {
        console.log("urlStr step 2 --- ", { urlStr, endPoint, pathParams, queryParams, formData });

        for (const param of pathParams) {
            if (typeof param === "string") {
                urlStr += `/${param}`;
                console.log("urlStr step 3 --- ", { urlStr, endPoint, pathParams, queryParams, formData, param });
            } else if (typeof param === 'object' && param !== null &&
                (param.hasOwnProperty('map') || param.hasOwnProperty('preDefined'))) {
                const valueObj = await parseApiInput(formData, param);
                console.log("urlStr step 4 --- ", { urlStr, endPoint, pathParams, queryParams, formData, valueObj, param });
                for (const key in valueObj) {
                    urlStr += `/${valueObj[key]}`;
                    console.log("urlStr step 5 --- ", { urlStr, endPoint, pathParams, queryParams, formData, valueObj, param, key });
                }
            } else if (typeof param === 'object' && param !== null) {
                console.log("urlStr step 6 --- ", { urlStr, endPoint, pathParams, queryParams, formData, param });
                for (const key in param) {
                    urlStr += `/${key}/${param[key]}`;
                    console.log("urlStr step 7 --- ", { urlStr, endPoint, pathParams, queryParams, formData, param, key });
                }
            }
        }
    }

    // Fix 2: Properly handle query params with correct valueObj reference
    if (queryParams && Object.keys(queryParams).length > 0) {
        let delim = "?";

        if (queryParams.hasOwnProperty('map') || queryParams.hasOwnProperty('preDefined')) {
            const valueObj = await parseApiInput(formData, queryParams);
            console.log("urlStr step 8 --- ", { urlStr, endPoint, pathParams, queryParams, formData, valueObj, delim });
            for (const qpKey in valueObj) {
                // Fix: Use valueObj[qpKey] instead of queryParams[qpKey]
                urlStr += `${delim}${qpKey}=${valueObj[qpKey]}`;
                console.log("urlStr step 9 --- ", { urlStr, endPoint, pathParams, queryParams, formData, valueObj, qpKey, delim });
                delim = "&";
            }
        } else {
            for (const qpKey in queryParams) {
                urlStr += `${delim}${qpKey}=${queryParams[qpKey]}`;
                console.log("urlStr step 10 --- ", { urlStr, endPoint, pathParams, queryParams, formData, qpKey, delim });
                delim = "&";
            }
        }
    }

    console.log("urlStr step 20 --- ", { urlStr, endPoint, pathParams, queryParams, formData });
    return urlStr;
};

// Retry logic
export const retryWithBackoff = async <T>(
    fn: () => Promise<T>,
    retries: number = 3,
    baseDelay: number = 500,
    successCodes?: any[],
    erroeCodes?: any[],
    onRetry?: (error: unknown, attempt: number, delay: number) => void
): Promise<T> => {
    let attempt = 0;

    while (attempt < retries) {
        try {
            return await (async () => {
                const res = await fn();
                const resp = (res as Response)?.clone();
                console.log("rinside etryWithBackoff 1 ------- ", res, successCodes, resp?.status)
                if ((!resp?.ok && !successCodes?.includes(resp?.status))) {
                    console.log("rinside retryWithBackoff 2 ------- ", resp?.ok, resp?.status)
                    return res;
                }
                return res;
            })();
        } catch (error) {
            attempt++;
            if (attempt >= retries) throw error;

            // const delay = baseDelay * Math.pow(2, attempt);
            const delay = Math.min(baseDelay * Math.pow(2, attempt), 5000); // max 5s
            onRetry?.(error, attempt, delay) || console.warn(`Retrying in ${delay}ms... (Attempt ${attempt})`);
            await new Promise(res => setTimeout(res, delay));
        }
    }
    throw new Error("Failed after max retries");
};

export const getMeaningfulDomPath = (
    el: HTMLElement,
    delimiter: string = " > "
): string => {
    if (!el) return "";

    const path: string[] = [];
    let current: HTMLElement | null = el;

    const skipIds = ["__next", "_app", "_document"]; // ignore Next.js wrappers
    const skitComps = ["Div", "div"];
    const allowedTags = [
        "header",
        "footer",
        "nav",
        "section",
        "article",
        "form",
        "button",
        "input",
        "img",
    ];

    while (current && current.nodeType === Node.ELEMENT_NODE) {
        let segment = "";

        const id =
            current.id && !skipIds.includes(current.id) ? `#${current.id}` : "";

        const nameAttr = current.getAttribute("name")
            ? `[name="${current.getAttribute("name")}"]`
            : "";

        // Try React Fiber displayName first
        let compName: string | undefined;
        const fiberKey = Object.keys(current).find((k) =>
            k.startsWith("__reactFiber$")
        );
        if (fiberKey) {
            const fiber = (current as any)[fiberKey];
            compName =
                fiber?.elementType?.displayName ||
                fiber?.elementType?.name ||
                fiber?.type?.displayName ||
                fiber?.type?.name;
        }

        // If no Fiber displayName, fallback to data-testid
        if (!compName) {
            compName = current.getAttribute("data-testid") || "";
            // console.log("segment --- 1 --- ", compName)
        }

        compName = !skitComps.includes(compName || "") ? compName : "";

        if (compName || id || nameAttr) {
            segment = !skitComps.includes(segment) ? compName : "";
            segment += `${id}${nameAttr}`;
            // console.log("segment --- 2 --- ", compName, segment)
        } else if (current.getAttribute("role")) {
            segment = `[role="${current.getAttribute("role")}"]`;
            // console.log("segment --- 3 --- ", segment)
        } else if (allowedTags.includes(current.tagName.toLowerCase())) {
            segment = current.tagName.toLowerCase();
            // console.log("segment --- 4 --- ", segment)
        }

        if (segment) {
            // console.log("segment --- 4 --- ", segment)
            // if(!skitComps.includes(segment)) {
            path.unshift(segment);
            // }
        }

        current = current.parentElement;
    }

    return path.join(delimiter);
};
function warn(warning: string): void {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(warning); // eslint-disable-line no-console
    }
}

export const logger = {
    warn,
};

export const safeStringify = (obj: any = {}) => {
    const seen = new WeakSet();
    return obj ? JSON.stringify(obj, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (seen?.has(value)) return '[Circular]';
            seen?.add(value);
        }
        return value;
    }, 2) : obj;
}

// export const filterHtmlAttributes: Record<string, any> = (props: Record<string, any>, tagName: string) => {
export const filterHtmlAttributes = (
    props: Record<string, any>,
    tagName: string
): Record<string, any> => {
    const globalAttributes = new Set([
        'id', 'class', 'className', 'style', 'title', 'lang', 'dir', 'hidden', 'tabIndex', 'draggable',
        'role', 'accessKey', 'contentEditable',
    ]);

    const eventAttributes = new Set([
        "onClick",
        "onDoubleClick",
        "onMouseDown",
        "onMouseMove",
        "onMouseOut",
        "onMouseOver",
        "onMouseUp",
        "onKeyDown",
        "onKeyPress",
        "onKeyUp"
    ]);


    // Tag-specific allowed attributes
    const tagSpecificAttributes: Record<string, Set<string>> = {
        input: new Set(['type', 'value', 'name', 'placeholder', 'checked', 'disabled', 'readOnly']),
        a: new Set(['href', 'target', 'rel', 'download']),
        img: new Set(['src', 'alt', 'width', 'height']),
        button: new Set(['type', 'disabled', 'name', 'value']),
        div: new Set([]), // Accepts only global + aria/data
    };

    const validAttributes = new Set([
        ...globalAttributes,
        ...eventAttributes,
        ...(tagSpecificAttributes[tagName] ?? []),
    ]);

    const isDataOrAria = (key: string) =>
        key.startsWith('data-') || key.startsWith('aria-');

    return Object.fromEntries(
        Object.entries(props).filter(([key]) =>
            validAttributes.has(key) || isDataOrAria(key)
        )
    );
};

export const safeHtmlProps = (HTMLElementProps: any) => Object.fromEntries(
    Object.entries(HTMLElementProps).filter(([_, value]) =>
        typeof value !== 'object' || value === null || value instanceof String || value instanceof Number
    )
);


export const activeLocale = ({ cookieLocale, pathLocale, localeList, dLocale }: { cookieLocale: string | undefined, localeList: string[] | undefined, pathLocale: string, dLocale: string }) => {

    if (!cookieLocale && !localeList?.includes(cookieLocale as string)) {
        if (localeList?.includes(pathLocale)) return pathLocale;
        return dLocale;
    } else {
        if (cookieLocale !== pathLocale) {           // segments[0] = pathLocale  = en(locale) or route "pt" "witw
            if (localeList?.includes(pathLocale)) return pathLocale;
            return dLocale;
        }
        return cookieLocale;
    }
}

// Add 'px' to height if it doesn't contain media units or numbers with units
export const addPxToValue = (value: string | undefined): string => {
    if (!value) return 'auto';
    
    // Skip if already has valid units (px, rem, em, %, vh, vw, etc.) OR media queries
    const validUnits = /\d+(px|rem|em|%|vh|vw|vmin|vmax|ex|ch|cm|mm|in|pt|pc)/;
    const mediaQuery = /@media/;
    
    if (validUnits.test(value) || mediaQuery.test(value)) {
        return value;
    }
    
    // If just a number (e.g. "500"), add 'px'
    return `${value}px`;
};